import React, { Component, Fragment } from 'react';

class CustomSubmit extends Component {
    constructor(props){
        super(props);
        this.state={
            disablebtn:false
        }
    }
    handleClick=(e)=>{
        this.disable_enableBtn(true).then(()=>{
            if(this.props.handleSubmit){
                this.props.handleSubmit(e, ()=>{
                    this.disable_enableBtn();
                });
            }else{
                this.disable_enableBtn(true);
            }
        });        
    }
    disable_enableBtn=(isDisable=false)=>{
        return new Promise((resolve, reject)=> {
            this.setState({disablebtn:isDisable});
            resolve(true);
          });
    }
    render() {
        const {disablebtn}=this.state;
        const {children}=this.props;
        return (
            <Fragment>
                <button {...this.props} disabled={disablebtn} onClick={this.handleClick}>
                   {disablebtn? <Fragment><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading</Fragment>:children
                   }
                </button>                
            </Fragment>
        );
    }
}

export default CustomSubmit;


// WEBPACK FOOTER //
// ./src/components/Misc/customSubmit/index.jsx